import moment from 'moment';

// Cores Bootstrap aplicadas a eventos de tarefa no calendário.
// Centralizado para que CalendarPage e TasksPage usem a mesma regra.
export const taskColor = (deadline: string, finished: boolean): string => {
  if (finished) return 'bg-success text-white';
  if (moment(deadline).isSame(moment(), 'day')) return 'bg-warning text-dark';
  if (moment(deadline).isBefore(moment(), 'day')) return 'bg-danger text-white';
  if (moment(deadline).isAfter(moment(), 'day')) return 'bg-info text-white';
  return 'bg-light text-dark';
};

export interface TaskDisplayFlags {
  filterLate: boolean;
  filterToday: boolean;
  filterFuture: boolean;
  filterFinished: boolean;
}

// Retorna 'none' para esconder o evento (filtro local do FullCalendar) ou
// 'auto' para exibir. A checagem `!finished` em cada categoria de deadline
// garante que tarefas concluídas sejam controladas só pelo filterFinished,
// independente da data — evita esconder uma concluída de hoje quando o
// filterToday está desmarcado.
export const taskDisplay = (
  deadline: string,
  finished: boolean,
  flags: TaskDisplayFlags,
): 'none' | 'auto' => {
  if (
    (finished && !flags.filterFinished) ||
    (moment(deadline).isSame(moment(), 'day') && !finished && !flags.filterToday) ||
    (moment(deadline).isBefore(moment(), 'day') && !finished && !flags.filterLate) ||
    (moment(deadline).isAfter(moment(), 'day') && !finished && !flags.filterFuture)
  )
    return 'none';
  return 'auto';
};
